import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './SignIn.css';

const SignIn = ({ onSignIn }) => { // Adding onSignIn prop
    const [formData, setFormData] = useState({ email: '', password: '' });
    const [signInStatus, setSignInStatus] = useState({
        isSuccess: true,
        message: ''
    });
    const navigate = useNavigate();

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/signin`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData),
                credentials: 'include',
            });
            const data = await response.json();

            if (response.ok) {
                setSignInStatus({ isSuccess: true, message: 'Sign in successful' });
                onSignIn(); // Calling the onSignIn function passed as prop
                navigate('/'); // Redirect to the homepage
            } else {
                setSignInStatus({ isSuccess: false, message: data.error || 'Sign in failed' });
            }
        } catch (error) {
            setSignInStatus({ isSuccess: false, message: 'An error occurred during sign in' });
        }
    };

    const handleForgotPassword = () => {
        navigate('/forgot-password'); // Redirect to the forgot password page
    };

    const handleSignUp = () => {
        navigate('/register'); // Redirect to the sign up page
    };

    return (
        <div className="sign-in-container">
            <img src="./favicon.svg" alt="Interview Prep Logo" className="sign-in-avatar" />
            <h1 className="sign-in-title">Boost Interview</h1>
            <form className="sign-in-form" onSubmit={handleSubmit}>
                <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    onChange={handleInputChange}
                    value={formData.email}
                />
                <input
                    type="password"
                    name="password"
                    placeholder="Password"
                    onChange={handleInputChange}
                    value={formData.password}
                />
                <button type="submit" className="sign-in-button">Sign In</button>
            </form>
            {signInStatus.message && (
                <div className={`alert ${signInStatus.isSuccess ? 'alert-success' : 'alert-danger'}`}>
                    {signInStatus.message}
                </div>
            )}
            <div className="login-help">
                <button onClick={handleForgotPassword} className="text-button">Forget Password?</button>
                <button onClick={handleSignUp} className="text-button">Sign Up</button>
            </div>
        </div>
    );
};

export default SignIn;
